import posthog from "posthog-js";
import { hasAnalyticsConsent } from "./cookieConsent";
import { getPostHogConfig, initPostHogIfNeeded } from "./posthogConfig";

export function captureAnalyticsEvent(eventName, properties) {
  const { enabled } = getPostHogConfig();
  if (!enabled || !hasAnalyticsConsent()) return;
  if (!initPostHogIfNeeded()) return;
  posthog.capture(String(eventName || "").trim(), properties && typeof properties === "object" ? properties : undefined);
}
